import { AnnotatedNotitie } from './annotatedNotitieTypes';
import { isRangeCovered } from './markCoverage';

const EMAIL_ADDRESS_REGEX = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const DUTCH_PHONE_NUMBER_REGEX = /(?:\+31|0031|0)(?:[\s().-]*\d){9}\b/g;

export function containsPrivacySensitiveData(notitie: AnnotatedNotitie): boolean {
  return hasUnprotectedMatch(notitie, EMAIL_ADDRESS_REGEX) || hasUnprotectedMatch(notitie, DUTCH_PHONE_NUMBER_REGEX);
}

function hasUnprotectedMatch(notitie: AnnotatedNotitie, regex: RegExp): boolean {
  regex.lastIndex = 0;

  for (const match of notitie.text.matchAll(regex)) {
    if (match.index === undefined) continue;

    const start = match.index;
    const end = start + match[0].length;

    if (!isPrivateRange(notitie, start, end)) {
      return true;
    }
  }

  return false;
}

function isPrivateRange(notitie: AnnotatedNotitie, start: number, end: number): boolean {
  return isRangeCovered(
    notitie.marks.filter((mark) => mark.type === 'PRIVATE').map((mark) => ({ start: mark.start, end: mark.end })),
    start,
    end,
  );
}
